import React, { ReactElement } from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import styled from 'styled-components';
import { colorsPalette } from '../../styles/colors-palette';
import { CheckboxChangeEvent } from 'antd/lib/checkbox/Checkbox';

interface CustomStyles {
  paddingLeft?: CSSSize | 0;
  paddingTop?: CSSSize | 0;
  fontSize?: CSSSize | 0;
  color?: Color;
}

interface CheckboxProps<ValueType> {
  checked?: boolean;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
  children?: React.ReactNode;
  value?: ValueType;
  className?: string;
  indeterminate?: boolean;
  customStyles?: CustomStyles;
}

function Checkbox<ValueType>({
  checked,
  disabled,
  onChange,
  children,
  value,
  className,
  indeterminate,
  customStyles,
}: CheckboxProps<ValueType>): ReactElement {
  const antOnChange = (e: CheckboxChangeEvent) => {
    onChange && onChange(e.target.checked);
  };
  return (
    <StyledCheckbox
      className={className}
      checked={checked}
      disabled={disabled}
      value={value}
      indeterminate={indeterminate}
      customstyles={customStyles}
      onChange={antOnChange}
    >
      {children}
    </StyledCheckbox>
  );
}

const StyledCheckbox = styled(AntCheckbox)<{ customstyles?: CustomStyles }>`
  &.ant-checkbox-wrapper {
    font-size: ${props => props.customstyles?.fontSize};
  }

  & {
    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${colorsPalette.dustyBlue500};
    }

    .ant-checkbox-indeterminate .ant-checkbox-inner:after {
      background-color: ${colorsPalette.dustyBlue500};
    }

    .ant-checkbox-indeterminate:hover .ant-checkbox-inner {
      border-color: ${colorsPalette.dustyBlue500} !important;
    }

    .ant-checkbox-checked:hover {
      &.ant-checkbox-inner {
        background-color: red;
      }
    }
    // animation color
    .ant-checkbox-checked::after {
      border-color: ${colorsPalette.dustyBlue500};
    }

    .ant-checkbox-disabled .ant-checkbox-inner {
      background-color: ${colorsPalette.lightGray100};
    }

    .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
      background-color: ${colorsPalette.lightGray300};
      border-color: ${colorsPalette.lightGray300};
    }

    .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: ${colorsPalette.white};
    }

    .ant-checkbox-wrapper:hover .ant-checkbox-inner,
    .ant-checkbox:hover .ant-checkbox-inner,
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${colorsPalette.dustyBlue500};
    }

    &.ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
    &.ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
      border-color: ${colorsPalette.dustyBlue500};
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      border-color: ${colorsPalette.dustyBlue500};
    }
  }

  &.ant-checkbox-wrapper {
    padding-top: ${props => props.customstyles?.paddingTop};
    padding-left: ${props => props.customstyles?.paddingLeft};
    color: ${props => props.customstyles?.color ?? colorsPalette.gray600};
  }
`;

export { Checkbox };
